module.exports = __webpack_public_path__ + "static/media/bkt.8ff53800.png";